import React, { useState } from 'react';
import { Box, Flex, Image } from '@chakra-ui/react';
import { useParams } from 'react-router-dom';
import RemoteSubmissionCard from './RemoteSubmissionCard';
import { RemoteSubmissionProvider } from './RemoteSubmissionProvider';
import { useTokens } from '../../../context/TokenProvider';
import { useGetRemoteSubmissionInviteByTokenSuspense } from '../../../services/api/generated/client';
import { unwrapModel } from '../../../services/api/unwrapModel';
import { ModalErrorProvider } from '../../modules/Modal/ModalErrorProvider';
import EvidenceSentCard from './EvidenceSent/EvidenceSentCard';
import RenderIfElse from '../../modules/RenderIf/RenderIfElse';
const RemoteSubmissionWrapper = () => {
    const tokens = useTokens();
    const { token } = useParams();
    const [remoteSubmission, setRemoteSubmission] = useState(undefined);
    const { data: response } = useGetRemoteSubmissionInviteByTokenSuspense(token);
    const invite = unwrapModel(response);
    if (!invite)
        return null;
    const handleSubmissionComplete = (submission) => {
        setRemoteSubmission(submission);
    };
    const handleSubmitAnother = () => {
        setRemoteSubmission(undefined);
    };
    return (React.createElement(RemoteSubmissionProvider, { value: { token } },
        React.createElement(Box, { "data-testid": "remote_submission_page", minH: "100vh", bg: tokens.Layer03 },
            React.createElement(Box, { "data-testid": "remote_submission__housing_app_logo", pl: tokens.Spacing05, pt: tokens.Spacing06 },
                React.createElement(Image, { h: "32px", w: "230px", objectFit: "scale-down", alt: "The Housing App", src: "/images/THA_logo.png" })),
            React.createElement(Flex, { justify: "center", py: tokens.Spacing08 },
                React.createElement(ModalErrorProvider, null,
                    React.createElement(RenderIfElse, { condition: !!remoteSubmission, then: React.createElement(EvidenceSentCard, { remoteSubmission: remoteSubmission, onSubmitAnother: handleSubmitAnother }), else: React.createElement(RemoteSubmissionCard, { invite: invite, onSubmitComplete: handleSubmissionComplete }) }))))));
};
export default RemoteSubmissionWrapper;
